import { pathOr } from 'ramda';

function sortByLabelOrder(labels) {
  return (a, b) => {
    return labels.indexOf(a) - labels.indexOf(b);
  };
}

export const validateModel = (payload) => {
  const {
    addressDetails,
    contactDetails,
    employmentDetails,
    financialDetails,
    personalDetails,
    reviewDetails: { meta }
  } = payload;

  const { name, ...restOfPersonalDetails } = personalDetails.validation;
  const {
    ADDRESS: address,
    PREVIOUS_ADDRESSES: previousAddress,
    residential_status: residentialStatus,
    HISTORY_INCOMPLETE: historyIncomplete
  } = addressDetails.validation;
  const dateMoved = pathOr(null, ['effective_period', 'from'], address);

  const validation = {
    addressDetails: {
      ...(address && address.ADDRESS_INVALID && { address: address.ADDRESS_INVALID }),
      ...(previousAddress && { previousAddress }),
      ...(residentialStatus && { residentialStatus }),
      ...(dateMoved && { dateMoved }),
      ...(historyIncomplete && { historyIncomplete })
    },
    contactDetails: contactDetails.validation,
    employmentDetails: employmentDetails.validation,
    financialDetails: financialDetails.validation,
    personalDetails: {
      ...name,
      ...restOfPersonalDetails
    }
  };
  const mappedValidation = Object.keys(meta)
    .sort(
      sortByLabelOrder([
        'personalDetails',
        'addressDetails',
        'contactDetails',
        'employmentDetails',
        'financialDetails'
      ])
    )
    .flatMap((metaItem) => {
      const { fields } = meta[metaItem];
      const validationKeys = Object.keys(validation[metaItem]);
      const validationMap = validationKeys.map((validationKey) => {
        return `${fields[validationKey]}`;
      });
      if (validationMap.length === 0) return null;
      return validationMap;
    })
    .filter((item) => item !== null);

  return mappedValidation;
};
